import React from 'react';
import {
  FeaturedDisplayContainer,
  FeaturedCard,
  FeaturedIcon,
  FeaturedContent,
  FeaturedTitle,
  FeaturedDescription,
  FeaturedDetail,
  FeaturedAnimation,
  AnimatedBorder
} from './styles';

interface Feature {
  icon: React.ReactNode;
  title: string;
  description: string;
  detail: string;
}

interface FeaturedDisplayProps {
  feature: Feature;
}

const FeaturedDisplay: React.FC<FeaturedDisplayProps> = ({ feature }) => {
  return (
    <FeaturedDisplayContainer>
      <FeaturedCard>
        <FeaturedContent key={feature.title}>
          <FeaturedIcon $active={true}>
            {feature.icon}
          </FeaturedIcon>
          <FeaturedTitle>
            {feature.title}
          </FeaturedTitle>
          <FeaturedDescription>
            {feature.description}
          </FeaturedDescription>
          <FeaturedDetail>
            {feature.detail}
          </FeaturedDetail>
        </FeaturedContent>
        <FeaturedAnimation>
          <AnimatedBorder />
        </FeaturedAnimation>
      </FeaturedCard>
    </FeaturedDisplayContainer>
  );
};

export default FeaturedDisplay;
